import React from "react";
import CompassRose from "../components/CompassRose";
import BotanicalMark from "../components/BotanicalMark";
import { useLang } from "../i18n/LanguageContext";

export default function Home({ onStart }) {
  const { t } = useLang();
  return (
    <div className="relative min-h-screen w-full flex flex-col overflow-hidden" data-testid="home-page">
      <div className="ac-ambient" />

      <BotanicalMark className="absolute -left-6 top-16 hidden sm:block" size={140} opacity={0.25} />
      <BotanicalMark className="absolute -right-8 bottom-10 rotate-180" size={160} opacity={0.2} />

      <header className="relative z-10 pt-8 sm:pt-10 px-6 flex items-center justify-between max-w-xl w-full mx-auto">
        <span className="ac-eyebrow" data-testid="brand-mark">{t.homeBrand}</span>
        <span className="ac-eyebrow">{t.homeFooterTag}</span>
      </header>

      <main className="relative z-10 flex-1 flex flex-col items-center justify-center px-6 py-10 max-w-xl w-full mx-auto text-center">
        <div className="ac-in ac-in-delay-1 mb-6 sm:mb-8">
          <CompassRose size={200} />
        </div>

        <p className="ac-eyebrow mb-4 ac-in ac-in-delay-2" data-testid="home-subtitle">
          {t.homeSubtitle}
        </p>

        <h1
          className="ac-display text-[44px] sm:text-6xl lg:text-7xl mb-5 ac-in ac-in-delay-2"
          data-testid="home-title"
        >
          Aroma <em>Compass</em>
        </h1>

        <p
          className="font-sans text-[15px] sm:text-lg leading-relaxed text-[color:var(--ac-ink-soft)] max-w-md mb-8 ac-in ac-in-delay-3"
          data-testid="home-intro"
        >
          {t.homeIntro}
        </p>

        <button
          className="ac-btn-primary ac-in ac-in-delay-4"
          onClick={onStart}
          data-testid="start-quiz-button"
        >
          {t.homeCta}
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
            <path d="M5 12h14M13 5l7 7-7 7" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>

        <p className="mt-10 font-serif italic text-[13px] tracking-wide text-[color:var(--ac-ink-muted)] ac-in ac-in-delay-5">
          {t.homeAuthor}
        </p>
      </main>

      <footer className="relative z-10 pb-8 px-6 text-center">
        <p className="text-[11px] font-mono uppercase tracking-[0.24em] text-[color:var(--ac-ink-muted)]">
          {t.homeShortTag}
        </p>
      </footer>
    </div>
  );
}
